import type { ContentType } from '@prisma/client';
import { z } from 'zod';
import { Content } from './content.js';
import { Tracking } from './tracking.js';

export interface ContentLink {
  sourceContentId: number;
  targetContentId: number;
  sourceContentType: ContentType;
  targetContentType: ContentType;
  createdAt: string;
}

type ContentWithOptionalTracking = Omit<Content, 'tracking'> & { tracking?: Tracking };

export interface ContentLinkListResult {
  outgoing: ContentWithOptionalTracking[];
  incoming: ContentWithOptionalTracking[];
}

export const contentLinkCreateSchema = z.object({
  targetContentId: z.number().int().positive(),
});

export type ContentLinkCreateInput = z.infer<typeof contentLinkCreateSchema>;
